import jwt_decode from 'jwt-decode';

import type { User, UserRoles } from 'containers/Settings/types';

type DecodedToken = {
  roles: UserRoles[];
  user_id: string;
  scopes?: User['type'];
  _default_team_id?: string;
};

export function decodeToken(t?: string | null): DecodedToken | null {
  if (!t) {
    return null;
  }

  try {
    return jwt_decode<DecodedToken>(t);
  } catch {
    console.error('Error decoding token');

    return null;
  }
}
